import React from 'react';
import { theme } from '../theme';
import { ChevronDownIcon } from './icons';

// ─── ChevronToggleButton ─────────────────────────────────
// Shared expand/collapse chevron chrome (circle + border + soft shadow), extracted from the
// Phase-0 Häufigste-Grund-Codes chevron so the ChatbotAnalyticsCard and the H-G-C card share
// one control. Rotation (180°) is driven by `open`; caller positions it via `style`.
export const ChevronToggleButton: React.FC<{
  open: boolean; onClick: () => void; ariaLabel: string; ariaControls?: string;
  orientation?: 'vertical' | 'horizontal'; style?: React.CSSProperties;
}> = ({ open, onClick, ariaLabel, ariaControls, orientation = 'vertical', style }) => {
  // vertical: down ⌄ (closed) ↔ up ⌃ (open). horizontal: right ▶ (closed) ↔ left ◀ (open),
  // for the sideways-expanding analytics card. Base rotation orients the down-chevron; `open` adds 180°.
  const base = orientation === 'horizontal' ? -90 : 0;
  return (
    <button type="button" onClick={onClick} aria-expanded={open} aria-controls={ariaControls} aria-label={ariaLabel}
      style={{
        width: 26, height: 26, borderRadius: '50%', background: theme.colors.white,
        border: `1px solid ${theme.colors.borderLight}`, boxShadow: '0 2px 6px rgba(0,13,102,0.14)',
        cursor: 'pointer', color: theme.colors.navy, display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 0, ...style,
      }}>
      <span style={{ display: 'inline-flex', transform: `rotate(${base + (open ? 180 : 0)}deg)`, transition: 'transform 0.42s cubic-bezier(0.4,0,0.2,1)' }}>
        <ChevronDownIcon size={14} />
      </span>
    </button>
  );
};
